import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=d1b11b3a&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=d1b11b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b11b3a",
  null
  
)

export default component.exports